<template>
  <div class="w-full md:w-full h-full flex items-stretch relative">
    <input
      type="text"
      :value="value"
      @blur="validate($event)"
      @input="sendAnswer($event)"
      class="h-full py-2 border w-full px-2 bg-transparent text-center font-family"
      :class="{
        'border-danger': errors.first('barcode'),
        'rounded-l-lg': errors.first('barcode'),
        'rounded-lg': !errors.first('barcode')
      }"
      v-validate="'required|min:13|max:20'"
      name="barcode"
    />
    <div
      class="px-2 flex items-center cursor-pointer border-danger rounded-r-lg border-left-0"
      :class="{ _info: isToolTip }"
      v-if="errors.first('barcode')"
      @click="isToolTip = !isToolTip"
    >
      <feather-icon class="text-danger" icon="InfoIcon" svgClasses="w-5 h-5" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false
    },
    Item: {
      type: Object,
      required: true,
      default: ""
    },
    change: {
      type: Promise | Function,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      isToolTip: false,
      code: ""
    };
  },
  computed: {
    answer: {
      get() {
        return this.value;
      }
    }
  },
  methods: {
    /**
     * Veifica que la cadena contenga solo valores numericos de 0 al 9
     * @param {string} value - Cadena de texto
     */
    isNumber(value) {
      var numbers = /^[0-9]+$/;
      return value.match(numbers);
    },
    /**
     * Verifica que el valor ingresado sea un caracter alfabetico y los remueve.
     * @param {string} value - Cadena de texto
     */
    deleteString(value) {
      return value.replace(/[a-z-A-Z-\W-\D]/g, "");
    },
    /**
     * Obtiene una cadena de texto que solo contiene valores numericos.
     * @param {string} value - Cadena de texto
     */
    getNumber(value) {
      if (this.isNumber(value)) return value;
      else {
        const number = this.deleteString(value);
        return number;
      }
    },
    /**
     * Valida la estructura del código de barras y remite al componente padre vue
     * @param {event} e
     */
    async sendAnswer(e) {
      const number = e.target.value;
      if (this.isNumber(number)) {
        const validate = await this.$validator.validateAll();
        this.$emit("input", number);
        this.$emit("validate", validate);
      } else {
        const getNumber = this.getNumber(number);
        e.target.value = getNumber;
        this.$emit("input", getNumber);
        const validate = await this.$validator.validateAll();
        this.$emit("validate", validate);
      }
    },
    /**
     * Valida el valor ingresado en la caja de texto al aplicar el evento perdida de foco.
     * @param {evento} e
     */
    async validate(e) {
      const validate = await this.$validator.validateAll();
      const getNumber = this.getNumber(e.target.value);
      this.$emit("input", getNumber);
      this.$emit("validate", validate);
      if (validate) this.change(e.target.value, this.Item);
    }
  },
  watch: {
    "errors.items": async function () {
      const vmId = this.errors.vmId;
      const items = this.errors.items;

      const element = items.find(item => item.vmId === vmId);
      if (!element) return (this.isToolTip = false);
    }
  }
};
</script>

<style lang="scss" scoped>
.font-family {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  font-weight: 400;
}

.border-danger {
  border: 1px solid rgba(234, 84, 85, 1) !important;
}

.border-left-0 {
  border-left: none !important;
}

._info::before {
  content: "El valor debe ser mínimo de 13 y máximo de 20 car\00E1\03F2teres.";
  position: absolute;
  width: 97%;
  left: 0;
  top: 36px;
  background-color: black;
  color: white;
  padding: 5px;
  z-index: 1;
  border-radius: 0.5rem !important;
}
</style>
